import { apiInterfaceForJson } from "../common/apiManager";

export const fetchTransfers = () => {
    return apiInterfaceForJson("/transfer/v1/", "GET");
};

export const createTransfer = (transferData) => {
    return apiInterfaceForJson("/transfer/v1/", "POST", transferData);
};

export const updateTransfer = (transferData) => {
    return apiInterfaceForJson("/transfer/v1/", "PUT", transferData);
};

export const approveTransfer = (approvalData) => {
    return apiInterfaceForJson("/transfer/v1/approve", "POST", approvalData);
};

export const rejectTransfer = (transferId) => {
    return apiInterfaceForJson("/transfer/v1/reject", "POST", { transferId });
};

export const getTransferHistory = (leadId) => {
    return apiInterfaceForJson(`/transfer/v1/history/${leadId}`, "GET");
};

export const deleteTransfer = (transferData) => {
    return apiInterfaceForJson("/transfer/v1/delete", "POST", transferData);
};